module.exports = __webpack_public_path__ + "static/media/help_Navegacion.e45cf619.png";